import React, { useEffect, useRef, useState } from "react";
import "./WinAnimaion.css";
import baccartchipscards from "../../../../assets/games/Baccarat/cardsandchips111.png"

const WinAnimation = (props) => {
    const sparkContainer = useRef(null);
    const animationFrameRef = useRef(null);
    const sparksRef = useRef([]);
    const [showWinAnimation, setShowWinAnimation] = useState(true);

    useEffect(() => {
        const startAnimationLoop = () => {
            const updateSparks = () => {
                const now = performance.now();
                const container = sparkContainer.current;

                if (!container) return;

                for (let i = sparksRef.current.length - 1; i >= 0; i--) {
                    const spark = sparksRef.current[i];
                    const elapsed = (now - spark.startTime) / 1000;
                    const progress = Math.min(elapsed / spark.duration, 1);

                    if (progress >= 1) {
                        if (spark.element.parentNode === container) {
                            container.removeChild(spark.element);
                        }
                        sparksRef.current.splice(i, 1);
                        continue;
                    }

                    const ease = 1 - Math.pow(1 - progress, 3);
                    spark.element.style.transform = `
                        translate(-50%, -50%)
                        translate(${spark.tx * ease}px, ${spark.ty * ease}px)
                        scale(${1 - ease * 0.7})
                    `;
                    spark.element.style.opacity = 1 - ease * 0.9;
                    spark.element.style.boxShadow = `0 0 ${spark.glow * (1 - ease)}px ${spark.color}`;
                }

                animationFrameRef.current = requestAnimationFrame(updateSparks);
            };

            animationFrameRef.current = requestAnimationFrame(updateSparks);
        };

        const createGiantSparkExplosion = () => {
            if (!showWinAnimation) return;

            const container = sparkContainer.current;
            if (!container) return;

            const fragment = document.createDocumentFragment();
            const now = performance.now();
            const sparkCount = 300;
            const vw = Math.max(1200);
            const vh = Math.max(2000);
            const viewportRatio = vw / vh;

            for (let i = 0; i < sparkCount; i++) {
                const spark = document.createElement('div');
                spark.className = 'spark';

                const angle = Math.random() * Math.PI * 2;
                const distance = 150 + Math.random() * 800;
                const tx = Math.cos(angle) * distance * viewportRatio;
                const ty = Math.sin(angle) * distance;
                const duration = 1.2 + Math.random() * 0.6;
                const size = 3 + Math.random() * 40;
                const hue = 30 + Math.random() * 30;

                const sparkData = {
                    element: spark,
                    tx, ty,
                    duration,
                    startTime: now,
                    glow: 5 + Math.random() * 8,
                    color: `hsl(${hue}, 90%, 60%)`
                };

                spark.style.cssText = `
                    width: ${size}px;
                    height: ${size}px;
                    background: ${sparkData.color};
                    opacity: 1;
                    box-shadow: 0 0 ${sparkData.glow}px ${sparkData.color};
                    transform: translate(-50%, -50%);
                    will-change: transform, opacity, box-shadow;
                `;

                fragment.appendChild(spark);
                sparksRef.current.push(sparkData);
            }

            container.appendChild(fragment);
        };

        startAnimationLoop();
        createGiantSparkExplosion();
        const interval = setInterval(createGiantSparkExplosion, 1800);

        return () => {
            clearInterval(interval);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, [showWinAnimation]);



    const [coinsData, setCoinsData] = useState(null);
    useEffect(() => {
        const coins = Array.from({ length: props.amount * 4 > 50 ? 50 : props.amount * 4 < 10 ? 10 : props.amount * 4 }).map((_, i) => {
            // const coins = Array.from({ length: 30 }).map((_, i) => {
            const left = Math.random() * 300;
            const duration = 1 + Math.random() * 3;
            const delay = Math.random() * 1;
            const size = 80 + Math.random() * 20;

            return (
                <div
                    key={i}
                    className="coin"
                    style={{
                        left: `${left}vw`,
                        animationDuration: `${duration}s`,
                        animationDelay: `${delay}s`,
                        fontSize: `${size}px`,
                    }}
                >
                    {/* 💰 */}
                    {/* 🪙 */}
                    <div>&#x1FA99;</div>
                    {/* <i className="fa-classic fa-solid fa-sack fa-fw"></i> */}
                </div>
            );
        });
        setCoinsData(coins);
        // }, [props.amount])
    }, [])

    return (
        <div className="win-container" style={{ visibility: props.showWinAnimation ? "visible" : "hidden" }}>
            <div className="coin-background">{coinsData}</div>
            <div className="rotating-rays"></div>
            <div className="win-text">
                <span className="win-title">
                    <span className="left_blast_side">
                        {props?.isbaccaratgame ? (
                            <img
                                src={baccartchipscards}
                                alt="Poker chips and playing cards"
                                className="chips-cards-image"
                            />
                        ) : (
                            "🎉"
                        )}

                        <div className="blast_paper_animation">
                            {[...Array(12)].map((_, i) => (
                                <div className="particle" key={`left-${i}`}></div>
                            ))}
                        </div>
                    </span>

                    YOU WIN!
                    <br />
                    {/* {props.amount} */}
                    <span className={props.isbaccaratgame? "bcrtright_blast_side" : "right_blast_side"}>
                
                         {props?.isbaccaratgame ? (
                            <img
                                src={baccartchipscards}
                                alt="Poker chips and playing cards"
                                className="chips-cards-image"
                            />
                        ) : (
                            "🎉"
                        )}

                   
                        <div className="blast_paper_animation">
                            {[...Array(12)].map((_, i) => (
                                <div className="particle" key={`right-${i}`}></div>
                            ))}
                        </div>
                    </span>
                </span>
            </div>
            <div className="spark-container" ref={sparkContainer} />
        </div>
    );
};

export default WinAnimation;
